// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__PGVrn","upload":"Small_upload__1kMkV","imageWrap":"Small_imageWrap__3RJ5_","removeBtn":"Small_removeBtn__2w4ql"};